/***
 *
 *   SIGN IN
 *   Sign in form for all account types (including master).
 *
 **********/

import {
  Animate,
  AuthContext,
  Card,
  Form,
  Row,
  ViewContext,
  useLocation,
  useNavigate,
} from "components/lib";
import { useContext, useEffect, useState } from "react";
import logo from "./images/black_logo.png";
import truck_image from "./images/truck.png";
import styles from "./styles.module.scss";

export function Signin(props) {
  // context
  const authContext = useContext(AuthContext);
  const viewContext = useContext(ViewContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: {
      label: "Email",
      type: "email",
      required: true,
    },
    password: {
      label: "Password",
      type: "password",
      required: true,
    },
    forgotpassword: {
      type: "link",
      url: "/app/forgotpassword",
      text: "Forgot your password?",
    },
  });

  useEffect(() => {
    // was an error message passed from the server router?
    const qs = location.search;

    if (qs.includes("error")) {
      const msg = decodeURIComponent(qs.substring(qs.indexOf("?error=") + 7));
      viewContext.notification.show(msg, "error");
    }
  }, [location.search, viewContext.notification]);

  useEffect(() => {
    function receiveMessage(e) {
      if (
        e.origin !==
        (window.location.host === "localhost:3000"
          ? "http://localhost:5002"
          : "https://admin.coverbadger.com")
      )
        return;

      localStorage.setItem("user", JSON.stringify(e.data));
    }

    window.addEventListener("message", receiveMessage);
  }, []);

  return (
    <Animate type="pop">
      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.header}>
            <img
              src={logo}
              alt="Logo"
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.location.href = "https://coverbadger.com";
              }}
            />
          </div>
          <div className={styles.wrapper}>
            <Row title="Login to account">
              <div className={styles.desc}>
                Enter your credentials to access your account
              </div>
              <Card restrictWidth center>
                <Form
                  inputs={form}
                  method="POST"
                  url={"/api/auth"}
                  buttonText={"Sign In"}
                  callback={(res) => {
                    res.data["2fa_required"]
                      ? navigate(`/app/signin/otp?token=${res.data.token}`)
                      : navigate(authContext.signin(res));
                  }}
                />
              </Card>
            </Row>
          </div>
          <div className={styles.footer}>Coverbadger ©2025</div>
        </div>
        <div
          className={styles.right}
          style={{ backgroundImage: "url(" + truck_image + ")" }}
        />
      </div>
    </Animate>
  );
}
